import { Control, FieldValues, Path, useController, useWatch, UseFormSetValue } from "react-hook-form";
import { Aircraft } from "../../../models/aircraft";
import Flight, { isIfrFlightRules } from "../../../models/flight";
import ListAicraftPage from "../../../pages/organization/aircraft/ListAircraftPage";
import ReadOnlyInputBox from "../../InputBox/ReadonlyInputBox";
import { EntityDetailsDisplayInfoFieldAircraft, getValitationRules } from "../EntityDetailsDisplayInfo";


interface EntityAircraftPickerProps<Entity extends FieldValues> {
    displayInfoInput: EntityDetailsDisplayInfoFieldAircraft<Entity>;
    setModalContent: React.Dispatch<React.SetStateAction<JSX.Element | null>>;
    control: Control<Entity, any>
    setValue: UseFormSetValue<Flight>
}

function EntityAircraftPicker<Entity extends FieldValues>({control, displayInfoInput, setModalContent, setValue}: EntityAircraftPickerProps<Entity>) {
  const {
    field: { value, onChange, ref},
    fieldState,
    formState: { isSubmitting, isValid },
  } = useController({
    name: displayInfoInput.key,
    control,
    rules: getValitationRules(displayInfoInput),
  });

    //IFR flight -> the picker badges IFR-certified aircraft and sorts them on top
    const flightRules = useWatch({ control, name: "flightRules" as Path<Entity> }) as Flight["flightRules"] | undefined;
    const isIfrPick = flightRules !== undefined && isIfrFlightRules(flightRules);

    const aircraftName: string = (value as Aircraft)?.name

    const updateAircraft = (aircraft: Aircraft) => {
      onChange(aircraft);

      
      if (displayInfoInput.parentEntity === "Flight") {
        setValue('cruiseSpeed', aircraft.cruiseSpeed);
        setValue('equipmentCodes', aircraft.equipmentCodes);
        setValue('surveillanceEquipmentCodes', aircraft.surveillanceEquipmentCodes);
        setValue('field18Remarks', aircraft.field18Remarks);
        setValue('sarEquipment', aircraft.sarEquipment);
        setValue('operatorName', aircraft.operatorFullName);
        setValue('pbn', aircraft.pbnCapabilities);
        setValue('field18Nav', aircraft.field18Nav);
        setValue('field18Com', aircraft.field18Com);
        setValue('field18Dat', aircraft.field18Dat);
        setValue('ifrFuelPerHour', aircraft.fuelPerHour);
        setValue('ifrMaxMass', aircraft.wb?.maxMass ?? aircraft.mtow);
        setValue('wb', { status: "not-calculated", loads: [] })
        setValue("fuelOnBoard", [])
      }
      
      setModalContent(null);
    }

    return (
      <>
        <ReadOnlyInputBox
          inputRef={ref}
          value={aircraftName ?? ""}
          isDisabled={(isValid && isSubmitting) || (displayInfoInput.disabled ?? false)}
          name={displayInfoInput.name}
          fieldState={fieldState}
          onClick={() => {
            setModalContent(
              <ListAicraftPage
                onAircraftSelected={updateAircraft}
                ifrPick={isIfrPick}
              />
            );
          }}
        />
      </>
    );
}

export default EntityAircraftPicker;